export const optionsAvailable = (type) => {
  if (
    [
      'RADIO_BUTTONS',
      'CHECKBOX',
      'TEXT_INPUT',
      'IMAGE_UPLOAD',
      'SCORE_PREDICTOR',
      'DROPDOWN',
    ].includes(type)
  ) {
    return true;
  }
  return false;
};
export const questionValueToPayload = (questionValue, type) => {
  if (!Array.isArray(questionValue) || questionValue.length === 0) {
    throw new Error('Wrong values');
  }
  if (type === 'TEXT_INPUT') {
    return {
      title: '',
      fieldId: questionValue[0].fieldId || null,
    };
  }
  if (type === 'IMAGE_UPLOAD') {
    return {
      imageUrl: questionValue[0].imageUrl || null,
    };
  }
  if (type === 'PLAYER_PICKER') {
    return {
      teamId: questionValue[0].value,
    };
  }
  return {
    availableOptions: questionValue.map((item) => ({
      id: item.id,
      title: item.value,
      isValidAnswer:
        item.isValidAnswer !== undefined ? item.isValidAnswer : false,
    })),
  };
};

export const payloadToQuestionValue = (payload, type) => {
  if (type === 'TEXT_INPUT') {
    return [
      {
        id: 0,
        value: '',
        fieldId: payload?.fieldId || null,
      },
    ];
  }
  if (type === 'IMAGE_UPLOAD') {
    return [
      {
        id: 0,
        value: payload.imageUrl,
      },
    ];
  }
  if (type === 'PLAYER_PICKER') {
    return [
      {
        id: 0,
        value: payload.teamId,
      },
    ];
  }
  return payload.availableOptions.map((item) => ({
    id: item.id,
    value: item.title,
    isValidAnswer:
      item.isValidAnswer !== undefined ? item.isValidAnswer : false,
  }));
};
export const isValidAnswerAllowed = (type) => {
  return ['SCORE_PREDICTOR', 'DROPDOWN', 'CHECKBOX', 'RADIO_BUTTONS'].includes(
    type
  );
};
